import React from 'react';
import { BCTag, BCLoading } from '@bimser/components';
import Style from '../../../../../assets/FileSelectorStyle.scss';
import IFileSelectorItemProps from '../entities/IFileSelectorItemProps';
import { getDmIcon, DmObjectType } from '@bimser/common';

import classNames from 'classnames/bind';
const cx = classNames.bind(Style);

const FileSelectorItem = (props: IFileSelectorItemProps) => {
	const onRemove = React.useCallback(() => {
		if (props.allowRemove) {
			props.onRemove(props.item.key);
		}
	}, []);

	const renderedItemContent = React.useMemo(
		() => (
			<BCLoading show={props.item.isLoadingItem}>
				{getDmIcon(DmObjectType.File, Style.FileIcon, props.item.text)}
				<span
					className={Style.FileText}
					title={props.item.text}
				>
					{props.item.text}
				</span>
			</BCLoading>
		),
		[props.item]
	);

	const onClickItem = React.useCallback(() => {
		props.onClick(props.item.key);
	}, []);

	return (
		<div onClick={onClickItem}>
			<BCTag
				closable={!props.item.isLoadingItem && !props.readOnly && props.allowRemove}
				text={renderedItemContent}
				className={cx({ FileSelectorTag: true, Viewable: props.allowView })}
				onClose={onRemove}
			/>
		</div>
	);
};

export default FileSelectorItem;
